"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var factorySvgIcon_1 = __importDefault(require("./utils/factorySvgIcon"));
var SvgEditFilled = function (props) {
    var color = props.color;
    return (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m17.707 3.293 4 4a1 1 0 0 1 0 1.414L20 10.414V19a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h8.586l1.707-1.707a1 1 0 0 1 1.414 0ZM9 13.414l8-8L19.586 8l-8 8H9v-2.586Z", fill: color }));
};
exports.default = factorySvgIcon_1.default(SvgEditFilled);
//# sourceMappingURL=SvgEditFilled.js.map